import { render, staticRenderFns } from "./IolSwitchField.vue?vue&type=template&id=e21491c6"
import script from "./IolSwitchField.vue?vue&type=script&lang=js"
export * from "./IolSwitchField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports